import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { helperGetStaticContentUrl } from 'helpers/RouteHelper';
import Style from './Img.module.scss';

const Loader = props => {
  const {
    theme = {},
    buttonLoader = false,
    center = false,
    className = null,
    collections = false,
    setLoading = () => null,
  } = props;

  const classes = !buttonLoader
    ? classNames([
        className,
        center ? Style.centerLoader : Style.loadingContainer,
        theme.loadingContainer,
      ])
    : null;

  useEffect(() => {
    if (setLoading) setLoading(true);
    return () => {
      if (setLoading) setLoading(false);
    };
  }, [setLoading]);

  return (
    <div className={collections ? '' : classes}>
      <img
        className={classNames(Style.imgContainer, buttonLoader && Style.buttonLoader)}
        src={helperGetStaticContentUrl('images', 'loader.png')}
        alt="Loading..."
      />
    </div>
  );
};

/* eslint react/require-default-props: 0 */
Loader.propTypes = {
  buttonLoader: PropTypes.bool,
  center: PropTypes.bool,
  className: PropTypes.string,
  collections: PropTypes.bool,
  setLoading: PropTypes.func,
  theme: PropTypes.shape({}),
};

export default Loader;
